import { parseLocation } from 'automation-ui-routing/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const wireEnrollmentHistoryPropsFromURL = _WrappedComponent => props => {
  const {
    flowId: stringId
  } = props.overrideParams || props.match.params;
  const parsedQuery = parseLocation(props.location);
  const enrollmentId = Number(parsedQuery.enrollmentId);
  const logEventKey = parsedQuery.logEventKey;
  const flowId = Number(stringId);
  const versionId = parsedQuery.version ? Number(parsedQuery.version) : undefined;
  return /*#__PURE__*/_jsx(_WrappedComponent, Object.assign({}, props, {
    flowId: flowId,
    enrollmentId: enrollmentId,
    logEventKey: logEventKey,
    versionId: versionId
  }));
};